// extracted by mini-css-extract-plugin
module.exports = {"category":"Category_category__1tuAw","category__text":"Category_category__text__1MQM-"};